import { Record, Map } from "immutable";
import moment from "moment";

const FormsRecord = Record({
  createMediaCategory: new (Record({
    disabled: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    isAddModalVisible: false,
    fields: new (Record({
      name: "",
      description: ""
    }))()
  }))(),
  createMediaCategoryMedia: new (Record({
    disabled: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    fields: new (Record({
      name: "",
      description: "",
      fileUID: ""
    }))()
  }))()
});

// We can subclass FormRecord to add custom getters or methods.
export default class Forms extends FormsRecord {}



// WEBPACK FOOTER //
// ./src/common/mediaCategories/forms.js